import { Messages } from '../../../../codegen/Localize';
import { editFlow } from '../../../../flow/actions/EditFlowReduxAction';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ILaunchWebAuthoringAction } from '../../../../ts/ServerApi/types/actionNames';
import { IEntityAction } from './IEntityAction';

export const EditFlowEntityAction: IEntityAction<IContentInfo<'flow'>, ILaunchWebAuthoringAction> = {
  name: 'editFlow',
  translateName: Messages.editFlow,
  isVisible: () => FeatureFlags.MaestroFlowEditingServerV1,
  isClickable: (availableActions: ILaunchWebAuthoringAction) => FeatureFlags.MaestroFlowEditingServerV1 || !!(availableActions && availableActions.launchWebAuthoring), // TFSID 889168 - Premissions
  createReduxAction: (targetItems: IContentInfo[]) => editFlow(targetItems[0])
};
